import CreateBasicPromotion from './CreateBasicPromotion.container';

export default CreateBasicPromotion;
